// extracted by mini-css-extract-plugin
export default {"closeToTheLimit":"LetterCount_closeToTheLimit_nMAFP","overTheLimit":"LetterCount_overTheLimit_RFf0L"};